<template>
  <bita-modal
    :id="modalId"
    :title="title"
    :modal-lg="true"
    :isLoading="isLoading"
    @close="reset"
  >
    <div slot="body">
      <bita-ibox :is-loading="isLoadingModal">
        <div slot="body">
          <bita-form ref="form">
            <div slot="body">
              <div class="row">
                <bita-select
                  name="citiesOrgin"
                  label="مبدا"
                  ref="citiesOrginDropDown"
                  rules="required"
                  :validation-container-class="colWidth"
                  input-class="form-control"
                  :data-source="citiesOrgin"
                  data-text-field="name"
                  data-value-field="id"
                  v-model="dataForm.origin_id"
                  @change="getCitiesInit"
                />
                <bita-select
                  name="citiesDestination"
                  label="مقصد"
                  ref="citiesDestinationDropDown"
                  rules="required"
                  :validation-container-class="colWidth"
                  input-class="form-control"
                  :data-source="citiesDestination"
                  data-text-field="name"
                  data-value-field="id"
                  v-model="dataForm.destination_id"
                  @change="getCitiesInit"
                />
                <bita-select
                  name="loads"
                  label="نوع بار"
                  ref="loadsDropDown"
                  rules="required"
                  :validation-container-class="colWidth"
                  input-class="form-control"
                  :data-source="loads"
                  data-text-field="name"
                  data-value-field="id"
                  v-model="dataForm.load_id"
                />
                <bita-input
                  id="tonnage"
                  type="text"
                  name="tonnage"
                  label="تناژ"
                  rules="required|between:0,9999"
                  :validation-container-class="colWidth"
                  input-class="form-control"
                  v-model="dataForm.tonnage"
                />

                <bita-select
                  v-if="!isSilver"
                  id="check_tonnage"
                  name="check_tonnage"
                  label="آیا محدودیت تناژ چک شود؟"
                  validation-container-class="col-lg-4 col-md-6 col-sm-6"
                  input-class="form-control"
                  data-text-field="title"
                  data-value-field="value"
                  :data-source="[
                    { title: 'بله', value: 1 },
                    { title: 'خیر', value: 0 },
                  ]"
                  v-model="dataForm.check_tonnage"
                  rules="required"
                />
                <bita-select
                  name="categoryVehicleTypes"
                  label="دسته بندی نوع ماشین"
                  ref="categoryVehicleTypesDropDown"
                  rules="required"
                  :validation-container-class="colWidth"
                  input-class="form-control"
                  :data-source="categoryVehicleTypes"
                  data-text-field="name"
                  data-value-field="id"
                  v-model="dataForm.category_vehicle_type_id"
                />
                <Spinner
                  :is-loading="isLoadingVehicleTypes"
                  :class-name="colWidth"
                  styleName="align-self: center;"
                />
                <bita-select
                  v-if="this.isLoadingVehicleTypes === false"
                  name="vehicleTypes"
                  label="نوع ماشین"
                  ref="vehicleTypesDropDown"
                  rules="required"
                  :validation-container-class="colWidth"
                  input-class="form-control"
                  :data-source="vehicleTypes"
                  data-text-field="name"
                  data-value-field="id"
                  v-model="dataForm.vehicle_type_id"
                />
                <bita-input
                  type="text"
                  name="count"
                  label="تعداد"
                  rules="required|between:1,1000"
                  :validation-container-class="colWidth"
                  input-class="form-control"
                  v-model="dataForm.count"
                />
                <bita-input
                  id="tonnage"
                  type="number"
                  name="travel_time"
                  label="حداقل زمان حمل بار(مدت زمان سفر)"
                  rules="required|between:0,9999"
                  :validation-container-class="colWidth"
                  input-class="form-control"
                  v-model="dataForm.travel_time"
                  :subtitle="
                    dataForm.travel_time && dataForm.travel_time + ' ساعت'
                  "
                />
                <!-- <div v-if="cityTariff != 1" class="bg-warning col-12 py-2 my-2">
                  حداقل تعرفه بین مبدا و مقصد {{ cityTariff }} تومان میباشد!
                </div> -->
                <bita-select
                  v-if="$acl.isSuperAdmin || $acl.isSupportUser"
                  name="selectOwnerDropDown"
                  label="فرستنده بار(صاحب بار)"
                  rules="required"
                  ref="selectOwnerDropDown"
                  id="selectOwnerDropDown"
                  :validation-container-class="colWidth"
                  input-class="form-control"
                  :data-source="propsOwners"
                  data-text-field="name"
                  data-value-field="id"
                  v-model="dataForm.user_id"
                />
                <bita-select
                  v-if="!isSilver"
                  label="موقعیت جغرافیایی راننده چک شود؟"
                  id="force_in_location"
                  name="force_in_location"
                  rules="required"
                  :validation-container-class="colWidth"
                  input-class="form-control"
                  data-text-field="title"
                  data-value-field="value"
                  :data-source="[
                    { title: 'بله', value: 1 },
                    { title: 'خیر', value: 0 },
                  ]"
                  v-model="dataForm.force_in_location"
                />
                <bita-select
                  v-show="!isCarrier_test"
                  v-if="!isSilver"
                  id="is_exclusive"
                  name="is_exclusive"
                  label="آیا بار اختصاصی می‌باشد؟"
                  validation-container-class="col-lg-4 col-md-6 col-sm-6"
                  input-class="form-control"
                  data-text-field="title"
                  data-value-field="value"
                  :data-source="[
                    { title: 'بله', value: 1 },
                    { title: 'خیر', value: 0 },
                  ]"
                  v-model="dataForm.is_exclusive"
                />
                <bita-select
                  v-if="!isSilver"
                  name="salon"
                  label="سالن"
                  ref="salonDropDown"
                  rules="required"
                  :validation-container-class="colWidth"
                  input-class="form-control"
                  :data-source="salons"
                  data-text-field="name"
                  data-value-field="id"
                  v-model="dataForm.salon_id"
                  @change="getPriorities"
                />
              </div>
              <div class="row" v-if="!isSilver" v-show="!isCarrier_test">
                <bita-input
                  v-for="(priority, index) in dataForm.priorities"
                  :key="index"
                  v-model="priority.value"
                  :label="`اولویت ${priority.key}`"
                  name="priority"
                  validation-container-class="col-lg-4 col-md-6 col-sm-6"
                  input-class="form-control"
                />
              </div>
              <div class="row">
                <bita-datepicker
                  :class="colWidth"
                  type="date"
                  id="loading_at"
                  name="loading_at"
                  :rules="dataForm.id ? '' : 'notBeforeToday|required'"
                  label="تاریخ بارگیری"
                  :clearable="false"
                  inputClass="form-control"
                  v-model="dataForm.loading_at"
                />
                <bita-datepicker
                  id="expire_at"
                  :rules="dataForm.id ? '' : 'notBeforeToday|required'"
                  :validation-container-class="colWidth"
                  type="date"
                  name="expire_at"
                  label="تاریخ انقضا"
                  inputClass="form-control"
                  v-model="dataForm.expired_at"
                  subtitle="زمان مجاز برای رزرو بار تا پایان روز تاریخ انتخاب شده می باشد."
                />
                <bita-datepicker
                  :class="colWidth"
                  type="date"
                  id="delivery_at"
                  :rules="
                    dataForm.id
                      ? ''
                      : '|notBeforeToday|after:@تاریخ بارگیری|required'
                  "
                  name="delivery_at"
                  label="تاریخ تحویل"
                  :clearable="false"
                  inputClass="form-control"
                  v-model="dataForm.delivery_at"
                />
              </div>
              <div class="col-12 row justify-content-around align-items-center">
                <span>مبلغ صافی به ازای</span>
                <div class="btn-group btn-group-toggle">
                  <label
                    class="btn ml-2 active"
                    :class="dataForm.net_price_type == 1 && 'btn-primary'"
                    dir="rtl"
                  >
                    <input
                      v-model="dataForm.net_price_type"
                      type="radio"
                      name="net_price_type"
                      id="option1"
                      value="1"
                    />
                    کل بار
                  </label>
                  <label
                    class="btn active"
                    :class="dataForm.net_price_type == 2 && 'btn-primary'"
                  >
                    <input
                      v-model="dataForm.net_price_type"
                      type="radio"
                      name="net_price_type"
                      id="option2"
                      value="2"
                    />
                    هر تن
                  </label>
                </div>
                <bita-input
                  type="text"
                  name="netPrice"
                  :label="$currencyLabel('قیمت صافی')"
                  :rules="`required|fee|min_value:${cityTariff}`"
                  :validation-container-class="colWidth"
                  input-class="form-control"
                  v-model="dataForm.net_price"
                  :subtitle="
                    dataForm.net_price_type == 2
                      ? $thousandSeprator(
                          $round(
                            dataForm.net_price / dataForm.tonnage
                              ? dataForm.tonnage
                              : 0
                          )
                        ) +
                        ' ' +
                        'تومن بر تناژ '
                      : $thousandSeprator($round(dataForm.net_price)) +
                        ' ' +
                        'تومن '
                  "
                />
              </div>
              <div class="row">
                <bita-textarea
                  name="tools"
                  label="توضیحات"
                  validation-container-class="col-12"
                  inputClass="form-control"
                  v-model="dataForm.tools"
                />
              </div>
            </div>
          </bita-form>
        </div>
      </bita-ibox>
    </div>
    <div slot="footer" class="py-3">
      <div class="d-flex flex-column flex-md-row justify-content-between">
        <div class="col-12 col-md-2 mb-2">
          <bita-bootbutton
            type="primary"
            title="ثبت درخواست"
            icon="fa fa-check"
            class="w-100"
            @click.native="handleSubmit()"
          />
        </div>
        <div class="col-12 col-md-2">
          <bita-bootbutton
            class="w-100 bg-transparent text-danger border-0"
            type="danger"
            title="بستن"
            icon="fas fa-times"
            data-dismiss="modal"
          />
        </div>
      </div>
    </div>
  </bita-modal>
</template>
<script>
import Spinner from "../../../components/Spinner";
import LabelValue from "./LabelValue";
export default {
  components: { Spinner, "label-value": LabelValue },
  props: {
    modalId: {},
    isLoading: {},
    title: {},
    onSubmit: {},
    propsOwners: {
      type: Array,
    },
  },
  data() {
    return {
      colWidth: "col-lg-4 col-md-6 col-sm-6",
      dataForm: {
        origin_id: "",
        destination_id: "",
        load_id: "",
        tonnage: "",
        vehicle_type_id: "",
        count: "",
        net_price_type: "1",
        net_price: "",
        loading_at: "",
        expired_at: "",
        delivery_at: "",
        tools: "",
        force_in_location: 0,
        check_tonnage: 0,
        user_id: null,
        travel_time: 3,
        priorities: [],
      },
      isCarrier_test: false,
      isLoadingModal: false,
      isLoadingVehicleTypes: false,
      categoryVehicleTypes: [],
      vehicleTypes: [],
      loads: [],
      salons: [],
      citiesOrgin: [],
      citiesDestination: [],
      cityTariff: 0,
      isSilver: false,
    };
  },
  mounted() {
    if (this.$acl.roles.find((e) => e === "carrier_test")) {
      this.isCarrier_test = true;
    }
    if (this.$acl.roles.find((e) => e === "silver-subscription")) {
      this.isSilver = true;
    }
    this.getCategoryVehicleTypes();
    this.getCityOrgin();
    this.getCityDestination();
    this.getLoads();
  },
  watch: {
    "dataForm.category_vehicle_type_id": function(e) {
      this.getVehicleTypes(e);
    },
  },
  methods: {
    setDefaultDataform() {
      this.dataForm = {
        origin_id: "",
        destination_id: "",
        load_id: "",
        tonnage: "",
        vehicle_type_id: "",
        count: "",
        net_price_type: 1,
        net_price: "",
        loading_at: "",
        expired_at: "",
        delivery_at: "",
        tools: "",
        force_in_location: 0,
        check_tonnage: 0,
        user_id: null,
        travel_time: 3,
        priorities: [],
      };
      this.cityTariff = 1;
    },
    reset() {
      this.setDefaultDataform();
      this.$refs.form.reset();
    },
    getCityOrgin() {
      this.$persistClient("get", `cities?filter[unProvince]=0`).then((res) => {
        this.citiesOrgin = res.data;
      });
    },
    getCityDestination() {
      this.$persistClient("get", `cities?filter[unProvince]=0`).then((res) => {
        this.citiesDestination = res.data;
      });
    },
    getCategoryVehicleTypes() {
      this.$persistClient("get", `vehicle-types?filter[parent]=0`)
        .then((res) => {
          this.categoryVehicleTypes = res.data;
        })
        .finally(() => {});
    },
    getVehicleTypes(categoryId) {
      this.isLoadingVehicleTypes = true;

      this.$persistClient("get", `vehicle-types?filter[parent]=${categoryId}`)
        .then((res) => {
          this.vehicleTypes = res.data;
        })
        .finally(() => {
          this.isLoadingVehicleTypes = false;
        });
    },
    getLoads() {
      this.$persistClient("get", `loads?filter[unParentItem]=0`).then((res) => {
        this.loads = res.data;
      });
    },
    getCitiesInit() {
      const origin_city_id = this.dataForm.origin_id;
      const destination_city_id = this.dataForm.destination_id;
      if (!this.isDisabled) this.dataForm.salon_id = null;

      if (!!origin_city_id && !!destination_city_id) {
        this.isLoadingModal = true;
        this.$persistClient(
          "get",
          `cities/request-init?origin_city_id=${origin_city_id}&destination_city_id=${destination_city_id}`
        ).then((res) => {
          const data = res.data.data;
          this.cityTariff = data.tariff ?? 1;
          this.salons = [];

          data.terminals.forEach((terminal) => {
            this.salons.push(...terminal.salons);
          });

          this.isLoadingModal = false;
        });
      }
    },
    getPriorities(e) {
      const salon = this.salons.find((el) => el.id == e);
      this.dataForm.priorities = [];
      salon.priorities.forEach((priority) => {
        this.dataForm.priorities.push({
          key: priority,
          value: "",
        });
      });
    },
    handleSubmit() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.showResult = false;
          this.$emit("on-submit", this.dataForm);
        }
      });
    },
  },
};
</script>
